module.exports = __webpack_public_path__ + "static/stocktwits-3122086037066e9e6a735288b81a3df3.png";